export default function returnAuthorizations(state = {}, action) {
  switch (action.type) {
    case 'SET_NEW_QUANTITY_FOR_RETURN_UNIT': {
      const { returnAuthorization, returnUnitId, newQuantity } = action.payload

      let newReturnUnits

      if (newQuantity === 0) {
        // This return unit has no remaining units, so we should remove it from the RMA.
        newReturnUnits = returnAuthorization.return_units.filter(unit => unit.id !== returnUnitId)
      } else {
        newReturnUnits = returnAuthorization.return_units.map(unit => {
          if (unit.id === returnUnitId) {
            return { ...unit, quantity: newQuantity }
          }

          return unit
        })
      }

      return {
        ...state,
        [returnAuthorization.number]: {
          ...returnAuthorization,
          return_units: newReturnUnits,
        },
      }
    }

    default:
      return state
  }
}

export function getReturnAuthorizationsForOrderNumber(state, orderNumber) {
  return Object.values(state).filter(rma => rma.orderNumber === orderNumber)
}
